export default __webpack_public_path__ + "scripts/resources/assignments/en/aciddilution25/species.json";